<template>
  <div class="wj-ql-editor">
    <quill-editor
      class="quill-editor"
      v-model="currentTitle"
      ref="quillEditor"
      :options="config"
      @focus="onEditorFocus($event)"
      @blur="onEditorBlur($event)"
      @change="onEditorChange($event)"
    ></quill-editor>
    <input
      type="file"
      ref="imgInput"
      name="file"
      @change="handleFileChange('imgInput')"
      style="display: none;"
    />
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import uploadFile from "../utils/uploadFile";
import { uploadImgType } from "../utils/constant";

export default {
  props: ["content", "config", "option"],
  computed: {
    currentTitle: {
      get: function() {
        return this.content;
      },
      set: function(val) {
        this.changeTitle(val);
      }
    }
  },
  mounted() {
    this.$refs.quillEditor.quill
      .getModule("toolbar")
      .addHandler("image", this.imgHandler);
    this.$refs.quillEditor.quill.root.parentElement.previousElementSibling.style.display =
      "none";
    if (this.option && this.option.id && !this.currentTitle) {
      this.$refs.quillEditor.quill.focus();
    }
  },
  components: {
    quillEditor
  },
  methods: {
    changeTitle(val) {
      if (this.option) {
        this.$emit("onChange", val, this.option);
      } else {
        this.$emit("onChange", val);
      }
    },
    imgHandler(state) {
      this.addRange = this.$refs.quillEditor.quill.getSelection();
      if (state) {
        let fileInput = this.$refs["imgInput"];
        fileInput.click(); // 加一个触发事件
      }
    },
    handleFileChange(id) {
      let files = this.$refs.imgInput.files;
      uploadFile(files, uploadImgType, 2).then(url => {
        let quill = this.$refs.quillEditor.quill;
        let length = quill.getSelection().index;
        quill.insertEmbed(length, "image", url);
        quill.setSelection(length + 1);
      });
      this.$refs.imgInput.value = "";
    },
    onEditorBlur(e) {
      //失去焦点事件
      let children = this.$refs.quillEditor.quill.root.parentElement
        .previousElementSibling.children[1].firstElementChild;
      let isColorHidden = children.lastElementChild.getAttribute("aria-hidden");
      let isBgHidden = children.nextElementSibling.nextElementSibling.lastElementChild.getAttribute(
        "aria-hidden"
      );
      if (isColorHidden == "true" && isBgHidden == "true") {
        this.$refs.quillEditor.quill.root.parentElement.previousElementSibling.style.display =
          "none";
      }
    },
    onEditorFocus() {
      //获得焦点事件
      this.$refs.quillEditor.quill.root.parentElement.previousElementSibling.style.display =
        "block";
    },
    onEditorChange() {}
  }
};
</script>

<style lang="scss" scoped>
.quill-editor img {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/wj-quill-editor.vue